var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import BN from 'bn.js';
import { Asset } from '../types';
import { tickerPrice } from '../utils';
export class MoonbeamCrowdloanRewards {
    constructor() {
        this.addressLength = 20;
        this.identifiers = ['crowdloanRewards'];
    }
    extract(chain, account) {
        return __awaiter(this, void 0, void 0, function* () {
            const { api, name: chainName } = chain;
            const ticker = api.registry.chainTokens[0];
            const price = yield tickerPrice(ticker);
            // really wacky way of decoding shit...
            const [_, total, claimed, _dont_care] = api.createType('(U8, Balance, Balance, Vec<AccountId32>)', (yield api.query.crowdloanRewards.accountsPayable(account)).toU8a());
            const locked = total.sub(claimed);
            if (locked.isZero()) {
                return [];
            }
            const decimals = new BN(api.registry.chainDecimals[0]);
            return [
                new Asset({
                    name: `vested ${ticker}`,
                    ticker,
                    price,
                    transferrable: false,
                    amount: locked,
                    decimals,
                    origin: { account, chain: chainName, source: 'crowdloan rewards pallet' }
                })
            ];
        });
    }
}
